import React from 'react';

import config from '../../../../config';
import type { GoodfyndSiteSeo } from '../../types';

export interface GoodfyndSitesSeoHeadProps {
  seo: GoodfyndSiteSeo;
}

export function GoodfyndSitesSeoHead({ seo }: GoodfyndSitesSeoHeadProps) {
  const {
    businessName,
    canonicalUrl,
    description,
    image,
    jsonLd,
    siteUrl,
    title,
  } = seo;
  const isProduction = config.app.mode.isProduction;

  return (
    <>
      <title key="goodfynd-sites:title">{title}</title>
      <meta
        content={description}
        key="goodfynd-sites:description"
        name="description"
      />
      {isProduction && (
        <meta
          content="index,follow"
          key="goodfynd-sites:robots"
          name="robots"
        />
      )}
      <meta content="website" key="goodfynd-sites:og:type" property="og:type" />
      <meta content={title} key="goodfynd-sites:og:title" property="og:title" />
      <meta
        content={description}
        key="goodfynd-sites:og:description"
        property="og:description"
      />
      <meta
        content={businessName}
        key="goodfynd-sites:og:site_name"
        property="og:site_name"
      />
      {siteUrl && (
        <meta content={siteUrl} key="goodfynd-sites:og:url" property="og:url" />
      )}
      {image && (
        <meta
          content={image}
          key="goodfynd-sites:og:image"
          property="og:image"
        />
      )}
      {image && (
        <meta
          content={`${businessName} featured image`}
          key="goodfynd-sites:og:image:alt"
          property="og:image:alt"
        />
      )}
      <meta
        content={image ? 'summary_large_image' : 'summary'}
        key="goodfynd-sites:twitter:card"
        name="twitter:card"
      />
      <meta
        content={title}
        key="goodfynd-sites:twitter:title"
        name="twitter:title"
      />
      <meta
        content={description}
        key="goodfynd-sites:twitter:description"
        name="twitter:description"
      />
      {siteUrl && (
        <meta
          content={siteUrl}
          key="goodfynd-sites:twitter:url"
          name="twitter:url"
        />
      )}
      {image && (
        <meta
          content={image}
          key="goodfynd-sites:twitter:image"
          name="twitter:image"
        />
      )}
      {canonicalUrl && (
        <link
          href={canonicalUrl}
          key="goodfynd-sites:canonical"
          rel="canonical"
        />
      )}
      {jsonLd && (
        <script
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
          key="goodfynd-sites:jsonld"
          type="application/ld+json"
        />
      )}
    </>
  );
}
